import { FC } from "react";
import { CheckCrpQuantitiesTitle, CheckCrpQuantitiesTrigger } from "../atoms";
import * as Dialog from "../ui/dialog";
import { CheckCrpQuantitiesContent } from "../molecules";

export const CheckCrpQuantitiesDialog: FC = () => {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild id="check-crp-quantities-dialog-trigger">
        <CheckCrpQuantitiesTrigger />
      </Dialog.Trigger>
      <Dialog.Content
        onInteractOutside={(e) => e.preventDefault()}
        className="bg-indigo-25"
      >
        <Dialog.Header className="flex items-center gap-2.5 bg-mandarin-50">
          <CheckCrpQuantitiesTitle />
        </Dialog.Header>
        <CheckCrpQuantitiesContent />
      </Dialog.Content>
    </Dialog.Root>
  );
};
